export default __webpack_public_path__ + "assets/audio/ssml/break.20c03c4ea3504fb8406be5ae9b33cc51.mp3";